import {Component} from '@angular/core';
import {PolicyContractViewService} from '../../services/policy-contract-view.service';
import {Section} from './section';
import {AppConfigService} from '../../../../bonding_shared/services';

@Component({
  selector: 'bonus-malus-section',
  templateUrl: './bonus-malus-section.component.pug',
})
export class BonusMalusSectionComponent extends Section {
  self = this;

  constructor(protected policyContractViewService: PolicyContractViewService, public appService: AppConfigService) {
    super(policyContractViewService, appService);
  }

  changeNoClaimBonusUpFront(value: boolean): void {
    if (value) {
      this.policy.bonusPerSubinsured = true;
    }
  }
}
